import { BREAKPOINTS } from "../Constants/breakpoints";

class SmallHero {
    private element: HTMLElement;
    private textElement: HTMLElement | null;
    private initialMinHeight: number = 100;

    constructor(element: HTMLElement) {
        this.element = element;
        this.textElement = this.element.querySelector<HTMLElement>("h1");
        this.init();
    }

    private init(): void {
        this.updateHeight();
        window.addEventListener("resize", () => this.updateHeight());
    };

    private updateHeight(): void {
        if (window.innerWidth > BREAKPOINTS.tablet) {
            if (!this.textElement || !this.textElement.textContent) {
                return;
            }

            const charCount = this.textElement.textContent.length;

            const calculatedHeight = Math.max(422, charCount * 3.2);
            this.element.style.setProperty('min-height', `${calculatedHeight}px`);
        } else {
            this.element.style.setProperty('min-height', `${this.initialMinHeight}px`);
        }
    }
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.small-hero').forEach(element => {
        new SmallHero(element as HTMLElement);
    });
});